import React, { useEffect, useLayoutEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Router } from 'react-router-dom';
import { toast } from 'react-toastify';

import { useGetConfigLandingPageQuery } from '../../redux/reducers/config';


export const CustomRouter = ({ basename, children, history }) => {
  const [state, setState] = useState({
    action: history.action,
    location: history.location,
  });

  const { data: landing_page = {}, isFetching } = useGetConfigLandingPageQuery();
  const is_accepting_applications = landing_page?.is_accepting_applications;

  useLayoutEffect(() => history.listen(setState), [history]);

  // Check if current path is a register route and if applications are closed
  useEffect(() => {
    // Only check if config has loaded and applications are explicitly closed
    if (!isFetching && is_accepting_applications === false && state.location.pathname.startsWith('/register')) {
      toast.error('Applicant Portal is currently closed.');
      history.push('/');
    }
  }, [isFetching, is_accepting_applications, state.location.pathname, history]);

  return (
    <>
      <Router
        basename={basename}
        location={state.location}
        navigationType={state.action}
        navigator={history}>
        {children}
      </Router>
    </>
  );
};


CustomRouter.propTypes = {
  basename: PropTypes.string,
  children: PropTypes.element,
  history: PropTypes.object,
};


export default CustomRouter;
